import React from "react";
import { FF, T } from "../lib/constants";
import { Chevron } from "./ui";

export default function BackBtn({ label, onClick }) {
  return (
    <button type="button" onClick={onClick} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "none", border: "none", cursor: "pointer", fontSize: 14, fontWeight: 600, color: T.muted, margin: "0 0 14px -6px", padding: "6px 8px 6px 4px", borderRadius: 8, fontFamily: FF, minHeight: 36 }}>
      <Chevron dir="left" size={18} />{label}
    </button>
  );
}
